export default {
  policyFileNotFound: 'ملف الوثيقة غير موجود',
  policyFileNotFoundDescription:
    'لم يتم العثور على مستند الوثيقة المطلوب. يرجى التواصل مع الدعم إذا كنت تعتقد أن هذا خطأ.',
  goToHome: 'الرئيسية',
} as const
